import { observable } from "mobx";
import { ContactPersons } from "./ContactPersons";
import { DeliveryLocation } from "./DeliveryLocation";

export class OrderCustomer {
    @observable id: string;
    @observable name: string;
    @observable taxId: string;
    @observable deliveryLocation: DeliveryLocation;
    @observable contactPersons: Array<ContactPersons>;
    @observable ERPDeliveryLocationReferenceCode: string;
    @observable ERPCustomerReferenceCode: string;

    constructor() {
        this.id = "";
        this.name = "";
        this.taxId = "";
        this.deliveryLocation = new DeliveryLocation();
        this.contactPersons = [];
        this.ERPDeliveryLocationReferenceCode = "";
        this.ERPCustomerReferenceCode = "";
    }
}